
import { defineComponent } from "vue";
import router from "@/router";
import {
    IEnrollmentPhysicalFoldersModel, IAcademicYearModel, ICourseGroupsModel,
    ICoursesModel
} from "@/interfaces/modules";
import EnrollmentPhysicalFoldersService from "@/api/Configuration/EnrollmentPhysicalFoldersService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import CourseGroupsService from "@/api/Aula/CourseGroupsService";
import CoursesService from "@/api/Aula/CoursesSevice";
import { SHOW_PRESCHOOL } from "@/enums";
export default defineComponent({
    name: "EnrollmentPhysicalFoldersContent",
    data() {
        return {
            academicYears: [] as IAcademicYearModel[],
            coursesGroup: [] as ICourseGroupsModel[],
            courses: [] as ICoursesModel[],
            form: {
                loading: true,
                dialog: false,
                valid: false,
                record: {} as IEnrollmentPhysicalFoldersModel,
                rules: {
                    required: [(v: any) => !!v || "Este campo es requerido"],
                },
            },
            table: {
                filters: { search: "" },
                currentPage: 1,
                loading: false,
                headers: [
                    { key: "Folio", label: "Folio", sortable: true },
                    { key: "FolderCode", label: "Código", sortable: true },
                    { key: "AcademicYear", label: "Año", sortable: true },
                    { key: "GradeId", label: "Curso", sortable: true },
                    { key: "GroupId", label: "Grupo", sortable: true },
                    { key: "SiteName", label: "Sede", sortable: true },
                    { key: "AreaName", label: "Área", sortable: true },
                    { key: "StorageCode", label: "Almacenamiento", sortable: true },
                    { key: "Enable", label: "Activo", sortable: true },
                    { key: "IsConfidential", label: "Confidencial", sortable: true },
                    { key: "CreatedByFormat", label: "Creación", sortable: true },
                    { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
                    { key: "action", label: "Acciones", sortable: false },
                ],
                records: [] as IEnrollmentPhysicalFoldersModel[],
                rowsPerPage: 10,
            },
        };
    },
    computed: {
        filteredItems(): IEnrollmentPhysicalFoldersModel[] {
            if (!this.table.filters.search) return this.table.records;
            const s = this.table.filters.search.toLowerCase();

            return this.table.records.filter((x) => {
                const values = [
                    x.Folio,
                    x.FolderCode,
                    String(x.AcademicYear ?? ""),
                    x.GradeId,
                    x.GroupId,
                    x.SiteName,
                    x.AreaName,
                    x.BuildingName,
                    x.FloorName,
                    x.RoomName,
                    x.StorageType,
                    x.StorageCode,
                    x.Shelf,
                    x.RowLabel,
                    x.ColumnLabel,
                    x.PositionLabel,
                    x.Side,
                    x.Notes,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();

                return values.includes(s);
            });
        },
        rows(): number {
            return this.table.records.length || 0;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.table.loading = true;
            this.table.records = await EnrollmentPhysicalFoldersService.GetAll();

            this.academicYears = await AcademicYearService.GetAcademicYears();
            this.courses = await CoursesService.GetCourses(SHOW_PRESCHOOL.No);
            this.coursesGroup = await CourseGroupsService.GetCourseGroups();
            this.table.loading = false;
        },
        async edit(Id: any) {
            router.push(`/configuration/folios-enrollments-edit/${Id}`);
        },
    },
});
